export enum ChartTypesEnum {
  bar_chart = 'bar_chart',
  summary_chart = 'summary_chart',
}
